type ApiErrorDialogListener = (message: string) => void;

let listener: ApiErrorDialogListener | null = null;
let pendingMessage: string | null = null;

export function showApiErrorDialog(message: string) {
  if (listener) {
    listener(message);
    return;
  }

  pendingMessage = message;
}

export function subscribeApiErrorDialog(nextListener: ApiErrorDialogListener) {
  listener = nextListener;

  if (pendingMessage) {
    nextListener(pendingMessage);
    pendingMessage = null;
  }

  return () => {
    if (listener === nextListener) {
      listener = null;
    }
  };
}
